import _ from 'underscore';
import Backbone from 'backbone';
import ProductThumbnail from '@component/product-thumbnail/src/views/mcom/ProductThumbnail';
import template from '../templates/partials/content-product-thumbnail.hbs';

module.exports = ProductThumbnail.extend({
  template,
  initialize() {
    if (!_.isUndefined(this.model)) {
      let content = this.model.get('content');

      if (!content && this.model.collection) {
        content = this.model.collection.content;
        if (!content) {
          content = (this.model.collection.options) ? this.model.collection.options.content : undefined;
        }
      }
      const newModel = _.extend(
        { content },
        this.model.get('product'),
      );

      this.model = new Backbone.Model(newModel);
      this.buildProductColorSwatch(this.model.get('traits'), this.model.get('detail'));
      this.model.set({ meta: Object.assign({}, this.model.get('meta'), this.options.pageMeta || {}) });
    }
  },
});
